import ztComponent from './ztMenuBar.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
